<div class="options-wrapper">
  <div class="options-content">
    <div class="row">
      <mat-checkbox color="primary" (change)="selectAll($event)"
                    [checked]="isAllCheckboxesTurnOn"
                    [indeterminate]="isSomeCompleted">
        {{ allSettingsCheckbox.title | translate }}
      </mat-checkbox>

      <mat-checkbox color="primary" *ngFor="let checkbox of checkboxes" [(ngModel)]="checkbox.state">
        {{ checkbox.title | translate }}
      </mat-checkbox>
    </div>
  </div>

  <div class="models" *ngIf="isBim">
    <div class="separator"></div>

    <form [formGroup]="modelsForm">
      <div class="pairs-wrapper" formArrayName="ModelToModelMapping">
        <div class="pair" *ngFor="let pair of modelToModelMapping.controls; let index = index" [formGroupName]="index">
          <mat-form-field>
            <mat-label>{{ 'sources.configuration.CopyConfigOptions.ModelCopyFrom' | translate }}</mat-label>
            <mat-select formControlName="FromModelId">
              <mat-option *ngFor="let model of copiedModels" [value]="model.Id"
                          [disabled]="isFieldDisable(model.Id, copyConfigMappingFields.FromModelId)">
                {{ model.LayerName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-icon>arrow_forward</mat-icon>

          <mat-form-field>
            <mat-label>{{ 'sources.configuration.CopyConfigOptions.ModelCopyTo' | translate }}</mat-label>
            <mat-select formControlName="ToModelId">
              <mat-option *ngFor="let model of destinationModels" [value]="model.Id"
                          [disabled]="isFieldDisable(model.Id, copyConfigMappingFields.ToModelId)">
                {{ model.LayerName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-icon class="remove-pair" (click)="removePair(index)">delete</mat-icon>
        </div>

        <button *ngIf="!isAllFieldExist" class="add-pair-button" mat-button (click)="addPair()">
          <mat-icon>add</mat-icon>
          <span>{{ 'sources.configuration.CopyConfigOptions.AddPair' | translate }}</span>
        </button>
      </div>
    </form>
  </div>

  <div class="controls">
    <button class="cancel-button" mat-button (click)="goBack()">{{ "system.cancel" | translate | uppercase }}</button>
    <button class="copy-button" mat-raised-button (click)="copy()" [disabled]="modelsForm.invalid">
      {{ "system.copy" | translate | uppercase }}
    </button>
  </div>
</div>

